<template>
  <v-container class="pt-2 pb-3 dashboard-view" fluid>
    <v-row>
      <v-col>
        <UserWelcome />
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <AnalyticsSummary />
    </v-row>

    <v-row align="center" class="mt-1" justify="center">
      <v-btn class="button-special" @click="$router.push('/book')">
        <v-icon class="mr-2" small>fa-regular fa-stream</v-icon>
        {{ $t("goToJournal") }}
      </v-btn>
      <v-btn v-if="
        ($store.state.user.isPro && !isEmbedded) ||
        ($store.state.user.isPro && includeMentor)
      " class="button-special ml-3" @click="$router.push('/mentor')">
        <v-icon class="mr-2" small>fa-regular fa-brain</v-icon>
        {{ $t("seeMoreInsights") }}
      </v-btn>
    </v-row>

    <v-spacer class="my-12" />
    <v-overlay :value="overlayPromo" :dark="false">
      <BigPromo :end-time="new Date(2021, 10, 27, 12)" :title="'BLACK FRIDAY'" @closeWindow="overlayPromo = false" />
    </v-overlay>
    <v-overlay :value="overlayAIPop" :dark="false">
      <AIPop :title="$t('popUpTitle')" :description="$t('popUpDescription')" :ctaText="$t('ctaText')"
        :ctaLink="ctaLinkLink" @closeWindow="handleClose" />
    </v-overlay>
    <v-overlay :value="overlayPeriodSummary" :dark="false">
      <PeriodSummary :from-date="fromDateSummary" :period="summaryPeriod" :to-date="toDateSummary"
        @closeSummary="closeSummary" />
    </v-overlay>
    <v-overlay v-model="overlayCompleteRegister" :dark="false" :opacity="0.77">
      <CompleteRegister @closeWindow="closeCompleteRegister" />
    </v-overlay>
  </v-container>
</template>

<script>
// Repositories
import AuthRepository from "../repositories/auth";
import AssetRepository from "../repositories/asset";
import BrokerAccountRepository from "../repositories/brokerAccount";
import StrategyRepository from "../repositories/strategy";
import ConsiderationRepository from "../repositories/consideration";
import AdRepository from "../ads/adRepository";

import { mapMutations, mapState } from "vuex";
import PeriodSummary from "../components/PeriodSummary";
import CompleteRegister from "@/views/Register/CompleteRegister";
import AnalyticsSummary from "@/views/User/components/AnalyticsSummary";
import BigPromo from "@/views/Subscription/components/BigPromo";
import AIPop from "@/views/Subscription/components/AIPopUp";
import UserWelcome from "@/views/User/components/UserWelcome";

export default {
  name: "GeneralDashboard",
  components: {
    UserWelcome,
    BigPromo,
    AnalyticsSummary,
    CompleteRegister,
    PeriodSummary,
    AIPop,
  },
  data() {
    return {
      bottomSheetActivator: true,
      overlayPromo: false,
      overlayCompleteRegister: false,
      firstAsset: false,
      overlayAIPop: false,

      // Period Summary
      overlayPeriodSummary: false,
      summaryPeriod: "",
      fromDateSummary: null,
      toDateSummary: null,
      // PopUp
      ctaLinkLink: "https://swiset.com/ai/",
    };
  },
  computed: {
    includeMentor() {
      return (
        this.isEmbedded &&
        this.$store.state.whitelabel.features.findIndex(
          (feature) => feature.feature.name === "MENTOR"
        ) !== -1
      );
    },
    isEmbedded() {
      return this.$store.state.whitelabel.partner !== null;
    },
    ...mapState({
      notificationDisplayed: state => state.user.notificationDisplayed,
    }),
  },
  watch: {
    overlayCompleteRegister() {
      this.bottomSheetActivator = !this.overlayCompleteRegister;
    },
    overlayPeriodSummary() {
      this.bottomSheetActivator = !this.overlayPeriodSummary;
    },
  },
  created() {
    this.validateAuthenticated();
    this.verifyPeriodSummary();
    this.init();
  },
  methods: {
    validateAuthenticated() {
      if (this.$store.state.token === "") this.$router.push("/");
    },
    ...mapMutations(["setNotificationDisplayed"]),
    handleClose() {
      this.overlayAIPop = false;
      this.setNotificationDisplayed(true); // Set notification displayed
    },
    verifyPeriodSummary() {
      if (!this.$store.state.user.notificationDisplayed) {
        let today = new Date();
        let now = new Date();
        if (now.getDay() === 6 || now.getDay() === 0 || now.getDay() === 1) {
          if (now.getHours() >= 5 && now.getHours() <= 11) {
            // Sunday and Monday
            now.setDate(now.getDate() - ((now.getDay() + 6) % 7)); // set to Monday of this week
            if (today.getDay() === 1) now.setDate(now.getDate() - 7); // set to previous Monday
            this.fromDateSummary = now;
            this.toDateSummary = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate() + 4
            );
            this.summaryPeriod = this.$t("weeklyPeriod");
            this.overlayPeriodSummary = true;
            this.setNotificationDisplayed(true);
          }
        }
      }
    },
    ...mapMutations([
      "setAssets",
      "setStrategies",
      "setConsiderations",
      "setBrokerAccounts",
      "setIsPro",
      "setAds",
    ]),
    async init() {
      await AssetRepository.allAssetsOfUser().then((response) => {
        this.setAssets(response.data);
        // if(response.data.length === 0)
        //    this.overlayAddAsset = true;
      });
      await AuthRepository.isPro().then((response) => {
        if (response.status < 400 && response.data) this.setIsPro(true);
        else this.setIsPro(false);
      });
      await StrategyRepository.allStrategiesOfUser().then((response) => {
        this.setStrategies(response.data);
      });
      await BrokerAccountRepository.allBrokerAccountsOfUser().then((response) => {
        this.setBrokerAccounts(response.data);
      });
      await ConsiderationRepository.getConsiderationsByUser(
        this.$store.state.user.id
      ).then((response) => {
        this.setConsiderations(response.data);
      });
      if (!this.$store.state.user.isPro)
        await AdRepository.getAllAds().then((response) => {
          this.setAds(response.data);
        });

      await window.sendinblue.identify(this.$store.state.user.email, {
        NOMBRE: this.$store.state.user.firstName,
        SURNAME: this.$store.state.user.lastName,
        USERNAME: this.$store.state.user.username,
        PHONE: this.$store.state.user.details.phoneNumber,
        COUNTRY: this.$store.state.user.details.country,
        PRO_ON: this.$store.state.user.isPro ? "1" : "0",
        LANG: this.$i18n.locale,
        CHANNEL: this.$store.state.user.details.channel,
        USAGE_STATE: this.$store.state.user.details.usageState,
        COMMERCIAL_STATE: this.$store.state.user.details.commercialState,
      });
    },
    closeSummary() {
      this.overlayPeriodSummary = false;
    },
    closeCompleteRegister() {
      this.overlayCompleteRegister = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "../global";

.dashboard-view {
  font-family: "Avenir" !important;

  .ratiocard {
    background-color: transparent !important;
    box-shadow: none !important;
  }

}

.theme--dark {
  .dashboard-view {
    .ratiocard {
      background-color: #232830 !important;
    }
  }
}

.upcoming-event {
  background-color: $black-color;
  border-radius: 20px;

  .head {
    color: $primary-color;
    font-size: 20px;
  }

  .content {
    color: $white-color;
  }
}

.button-special {
  background-color: var(--v-mainBtnBackground-base) !important;
  color: var(--v-mainBlack-base) !important;
  border: 0;

  .v-icon {
    color: inherit !important;
  }
}
</style>

